import React from "react";
import "./About.css";
import assImage from "../../Assets/download.png";
import { LeftTextPart } from "./LeftTextPart";

export const About = () => {
  return (
    <div
      name="about"
      className="w-full flex justify-center pt-20  h-full mb-20 md:mb-0 mt-20 md:mt-0"
    >
      <div className="md:w-3/4 w-full flex flex-col items-center justify-center md:flex-row gap-6 ">
        {/* <div className="w-1/2 flex flex-col gap-3">
          <h1 className="text-[#ccd6f6] text-xl text-left">
            Hello! My name is Brittany and I enjoy creating things that live on
            the internet. My interest in web development started back in 2012
            when I decided to try editing custom Tumblr themes — turns out
            hacking together a custom reblog button taught me a lot about HTML &
            CSS!
          </h1>

          <h1 className="text-[#ccd6f6] text-md text-left">
            Hello! My name is Brittany and I enjoy creating things that live on
            the internet. My interest in web development started back in 2012
            when I decided to try editing custom Tumblr themes — turns out
            hacking together a custom reblog button taught me a lot about HTML &
            CSS!
          </h1>

          <h1 className="text-[#ccd6f6] text-md text-left">
            Hello! My name is Brittany and I enjoy creating things that live on
            the internet.
          </h1>

          <h1 className="text-[#ccd6f6] text-md text-left">
            Hello! My name is Brittany and I enjoy creating things that live on
            the internet.
          </h1>
          <div className="flex gap-24 pl-4">
            <div className="flex flex-col">
              <ul className="style_list text-[#ccd6f6] marker:text-green-300">
                <li>JavaScript (ES6+)</li>
                <li>React</li>
                <li>React Hook</li>
                <li>React Native</li>
                <li>Redux Toolkit</li>
              </ul>
            </div>
            <div className="flex flex-col">
              <ul className="style_list text-[#ccd6f6] marker:text-green-300">
                <li>HTML5</li>
                <li>CSS3</li>
                <li>Tailwindcss</li>
                <li>Bootstrap</li>
                <li>Angular</li>
              </ul>
            </div>
            <div className="flex flex-col">
              <ul className="style_list text-[#ccd6f6] marker:text-green-300">
                <li>Node.js</li>
                <li>MongoDB</li>
                <li>Expressjs</li>
                <li>MYSQL</li>
                <li>Next.js</li>
              </ul>
            </div>
          </div>
        </div> */}
        <div className="md:w-2/3 hidden md:block ">
          <LeftTextPart />
        </div>

        <div className=" md:w-1/3 container flex flex-col pl-5 md:pl-0 md:ml-0 justify-start items-start md:mt-0 mt-56  ">
          <div className=" image z-10 ">
            <img
              src={assImage}
              alt="Girl in a jacket"
              width="300"
              height="300"
              className=" md:z-10000 z-1000  rounded-md "
            ></img>
          </div>

          <span className="inner mt-[-260px] ml-[10px] w-80 h-72 border-2 border-green-200 rounded-md "></span>
        </div>

        <div className="w-full block md:hidden  mb-44">
          <LeftTextPart />
        </div>
      </div>
    </div>
  );
};
